"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChooseMealsData = void 0;
var react_1 = require("react");
var MealDeliveryProvider_1 = require("./MealDeliveryProvider");
var MealDeliveryProvider_2 = require("./MealDeliveryProvider");
/**
 * Specialized hook for ChooseMeals screen
 * Provides data and actions specifically formatted for the choose meals use case
 * This is the common version that can be used by both web and mobile
 */
var useChooseMealsData = function () {
    var _a = (0, MealDeliveryProvider_1.useMealDeliveryContext)(), state = _a.state, actions = _a.actions, bridge = _a.bridge;
    var counts = (0, MealDeliveryProvider_2.useMealDeliveryCounts)();
    // Aggregate meal kit variants directly from our flat arrays
    var _b = (0, react_1.useMemo)(function () {
        var aggregateFunction = (bridge === null || bridge === void 0 ? void 0 : bridge.aggregateMealKitVariants) ||
            (function (items) {
                return items;
            });
        return {
            entrees: aggregateFunction(state.entrees),
            snacksAndSides: aggregateFunction(state.snacksAndSides),
        };
    }, [state.entrees, state.snacksAndSides, bridge]), entrees = _b.entrees, snacksAndSides = _b.snacksAndSides;
    return {
        loading: state.loading,
        error: state.error,
        isDirty: state.isDirty,
        entrees: entrees,
        snacksAndSides: snacksAndSides,
        // Use common counts logic
        maxEntrees: counts.maxEntrees,
        maxSnacksAndSides: counts.maxSnacksAndSides,
        selectedEntreesCount: counts.selectedEntreesCount,
        selectedSnacksAndSidesCount: counts.selectedSnacksAndSidesCount,
        // Display helpers
        entreeDisplay: counts.entreeDisplay,
        snacksDisplay: counts.snacksDisplay,
        updateSelection: actions.updateSelection,
        saveSelections: actions.saveSelections,
    };
};
exports.useChooseMealsData = useChooseMealsData;
